<template>
  <div class="spa" :style="{ '--base-color': $theme.basecolor, '--base-dark': $theme.basedark, '--base-light': $theme.baselight }">
    <div v-if="errore" class="spa-card shadow spa-messaggio">
      <fa :icon="['fas', 'exclamation-triangle']" class="spa-icona-grande" />
      <div>{{ t(errore) }}</div>
    </div>
    <div v-else-if="p" class="spa-card shadow spa-messaggio">
      <fa :icon="['fas', p.stato === 'A' ? 'times-circle' : 'spa']" class="spa-icona-grande" />
      <h2 v-if="p.stato === 'A'">{{ t("SPA_Annullata") }}</h2>
      <h2 v-else-if="p.annullabile">{{ t("SPA_AnnullaDomanda") }}</h2>
      <h2 v-else>{{ t("SPA_NonAnnullabile") }}</h2>
      <div class="spa-riepilogo">
        <div><span>{{ t("SPA_Nome") }}</span><b>{{ p.nome }}</b></div>
        <div><span>{{ t("SPA_Data") }}</span><b>{{ dataLunga(p.data) }}</b></div>
        <div><span>{{ t("SPA_Trattamento") }}</span><b>{{ p.trattamento }}</b></div>
        <div><span>{{ t("SPA_Orario") }}</span><b>{{ p.orario }}</b></div>
        <div><span>{{ t("SPA_Durata") }}</span><b>{{ p.durata }}'</b></div>
        <div v-if="p.stato !== 'A'"><span>&nbsp;</span><b>{{ t("SPA_Stato_" + p.stato) }}</b></div>
      </div>
      <div v-if="p.stato !== 'A' && p.annullabile" class="spa-btn" :class="{ disabilitato: invio }" @click="annulla">
        <fa v-if="invio" :icon="['fas', 'spinner']" spin />
        {{ t("SPA_Annulla") }}
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "../services/api";
import paginaService from "../services/pagina";

const LOCALI = { ita: "it-IT", ing: "en-GB", eng: "en-GB", ted: "de-DE", fra: "fr-FR", spa: "es-ES", por: "pt-PT", jap: "ja-JP" };

/**
 * Link dell'email: il cliente vede la sua prenotazione del trattamento e la
 * annulla (/spa/annulla?token=...). Il token dice struttura e prenotazione; la
 * lingua e' quella in cui ha prenotato.
 */
export default {
  data() {
    return {
      token: "",
      p: null,
      testi: {},
      errore: "",
      invio: false
    };
  },
  mounted() {
    paginaService.neutra(this);
    this.token = this.$route.query.token || "";
    apiService
      .get("BE_spa/annulla?token=" + encodeURIComponent(this.token))
      .then((resp) => {
        this.testi = resp.testi || {};
        this.p = resp.prenotazione;
        this.$store.db = resp.db;
        this.$store.idhotel = resp.idhotel;
        this.$store.lang = String(this.p.lingua || "ita").toUpperCase();
        this.$root.$emit("lang:request", this.$store.lang);
        paginaService.applica(this, resp.grafica);
      })
      .catch((resp) => {
        this.testi = (resp && resp.testi) || {};
        this.errore = (resp && resp.errori && resp.errori[0]) || "SPA_NonTrovata";
      });
  },
  methods: {
    t(chiave) {
      return this.testi[chiave] || chiave;
    },
    dataLunga(sql) {
      const [a, m, g] = String(sql || "").split("-").map(Number);
      return a ? new Date(a, m - 1, g).toLocaleDateString(LOCALI[String(this.p.lingua || "ita").toLowerCase()] || "it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "";
    },
    annulla() {
      if (this.invio) {
        return;
      }
      this.invio = true;
      apiService
        .post("BE_spa/annulla", { token: this.token })
        .then((resp) => {
          this.invio = false;
          this.p = resp.prenotazione;
        })
        .catch((resp) => {
          this.invio = false;
          this.errore = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
        });
    }
  }
};
</script>
